<aside class="left-sidebar" style="background: linear-gradient(180deg, #6c0d39 0%, #4f0a29 100%); box-shadow: 0 0 25px rgba(0,0,0,0.35);">

    <div class="scroll-sidebar" style="background: transparent;">
        <nav class="sidebar-nav" style="background: transparent;">
            <ul id="sidebarnav">

                <li class="nav-devider" style="border-top: 1px solid rgba(255,235,200,0.18); margin: 10px 0;">
                </li>

                <!-- RH -->
                <li *ngFor="let item2 of menuItems2">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;     
                            color:#f3e9d0;
                            transition:0.3s;
                        ">

                        <i class="fa-solid fa-building-user" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item2.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item2.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>
                <!-- RF -->
                <li *ngFor="let item3 of menuItems3">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;    
                            color:#f3e9d0;
                            transition:0.3s;
                        ">

                        <i class="fa-solid fa-hand-holding-dollar" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item3.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item3.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>
                <!-- Materiales -->

                <li *ngFor="let item7 of menuItems7">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;    
                            color:#f3e9d0;
                            transition:0.3s;
                        ">

                        <i class="fa-solid fa-cart-flatbed" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item7.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item7.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>


                <!-- Contabilidad -->
                <li *ngFor="let item6 of menuItems6">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;     
                            color:#f3e9d0;
                            transition:0.3s;
                        ">

                        <i class="fa-solid fa-calculator" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item6.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item6.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Reportes -->
                <li *ngFor="let item5 of menuItems5">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;
                            color:#f3e9d0;
                        ">

                        <i class="fa-solid fa-paste" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item5.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item5.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Catálogos -->
                <li *ngFor="let item of menuItems">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;
                            color:#f3e9d0;
                        ">

                        <i class="fa-solid fa-boxes-packing" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>

                <!-- Usuarios -->
                <li *ngFor="let item4 of menuItems4">

                    <a class="has-arrow waves-effect waves-dark" href="#" style="
                            text-decoration:none;
                            display:flex;
                            align-items:center;
                            padding:12px 15px;
                            background: transparent;
                            color:#f3e9d0;
                        ">

                        <i class="fa-solid fa-users" style="color:#f3e9d0; margin-right:10px;"></i>

                        <span class="hide-menu"><b>{{ item4.titulo }}</b></span>
                    </a>

                    <ul class="collapse" style="
                            background: linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%);
                            margin:0;
                            padding:0;
                        ">

                        <li *ngFor="let subMenuItem of item4.submenu" style="list-style:none;">

                            <a *ngIf="subMenuItem.mostrar" [routerLink]="subMenuItem.url" style="
                                    text-decoration:none;
                                    color:#f7f2e6;
                                    display:flex;
                                    align-items:center;
                                    padding:10px 30px;
                                    font-size:13px;
                                ">

                                <i class="fa-solid" [ngClass]="subMenuItem.icono" style="margin-right:8px; font-size:12px; color:#f3e9d0;"></i> {{ subMenuItem.titulo }}

                            </a>
                        </li>
                    </ul>
                </li>

            </ul>
        </nav>
    </div>


    <button type="button" class="btn btn-light" style="
                width:100%;
                padding:14px;
                text-align:left;
                border:none;
                background: linear-gradient(180deg, #6c0d39 0%, #4f0a29 100%);
                color:#f3e9d0;
                font-size:14px;
                cursor:pointer;
            " routerLink="/login">

        <i class="fa-solid fa-power-off"></i> Cerrar sesión
    </button>

</aside>